import { forwardRef } from 'react';
import { cx } from '@/lib/cx';
import styles from './AuthScreen.module.css';
import { CODE_LENGTH, normalizeCode } from './validation';

// maxLength намеренно не ставится: браузер обрезал бы вставку «12 34 56» до 6 символов
// вместе с пробелами ещё до нормализации, и цифры терялись бы.

interface Props {
  id: string;
  value: string;
  onChange: (value: string) => void;
  error?: boolean;
  describedBy?: string;
  disabled?: boolean;
}

/** Код из 6 цифр: одно поле, вставка из буфера, autocomplete one-time-code, 6 подчёркиваний-ячеек (AUTH-4). */
export const CodeInput = forwardRef<HTMLInputElement, Props>(function CodeInput(
  { id, value, onChange, error, describedBy, disabled },
  ref,
) {
  return (
    <div className={styles.codeWrap}>
      <input
        ref={ref}
        id={id}
        className={cx(styles.codeInput, error && styles.codeInputError)}
        value={value}
        onChange={(event) => onChange(normalizeCode(event.target.value))}
        inputMode="numeric"
        pattern="[0-9]*"
        autoComplete="one-time-code"
        placeholder="••••••"
        aria-invalid={error || undefined}
        aria-describedby={describedBy}
        disabled={disabled}
      />
      <div className={styles.cells} aria-hidden="true">
        {Array.from({ length: CODE_LENGTH }, (_, i) => (
          <span key={i} className={cx(styles.cell, value.length > i && styles.cellOn)} />
        ))}
      </div>
    </div>
  );
});
